import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "5",
  "slug": "how-satellite-imagery-changed-geography-education",
  "title": "What Satellite Archives Add to Geography Lessons",
  "excerpt": "Use dated images to ask how a place changed, then check other explanations.",
  "date": "2026-02-20",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1460186136353-977e9d6085a1?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Satellite archives let students compare a place at different times. That adds a kind of evidence a single textbook map cannot provide: observations of water, vegetation, and settlement at recorded dates. Landsat's record began in 1972, though usable coverage and detail vary by place and period."
    },
    {
      "type": "heading",
      "text": "Build a lesson around a change"
    },
    {
      "type": "paragraph",
      "text": "Choose two cloud-free views of the same reservoir, urban edge, or forest area. Keep the map extent, display bands, and scale consistent. Use similar seasons where possible, and give students the acquisition dates."
    },
    {
      "type": "paragraph",
      "text": "Ask them to describe the visible difference before explaining it. More exposed ground beside a reservoir is an observation. Drought as its cause is a hypothesis that needs rainfall, water-management, or other supporting evidence."
    },
    {
      "type": "heading",
      "text": "Make uncertainty part of the answer"
    },
    {
      "type": "paragraph",
      "text": "Have students mark parts of the image they cannot interpret: cloud, shadow, mixed land cover, or features smaller than a pixel. A comparison with different resolution may make the newer image appear more detailed without showing a real change on the ground."
    },
    {
      "type": "heading",
      "text": "Assess the explanation"
    },
    {
      "type": "paragraph",
      "text": "Ask for one annotated observation, one possible cause, and one source that could test it. Assess those separately from whether the student recognised the place. This is a proposed lesson structure; it does not establish that satellite imagery raises grades or replaces fieldwork."
    }
  ],
  "sources": [
    {
      "title": "NASA: Landsat programme and observation record",
      "url": "https://science.nasa.gov/mission/landsat/"
    }
  ],
  "relatedSlugs": [
    "satellite-imagery-education-teaching-geography",
    "what-are-landsat-satellites"
  ]
};
